import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { withNavItem } from 'react-skeletal-nav';
import { AbsoluteLinkTag, RelativeLinkTag } from './NavLinkTag';

import './NavItem.scss';

const NavItem = ({
  href,
  link,
  icon,
  iconColor,
  badgeText,
  onClick,
  title,
  children,
  route,
  isInRoute,
}) => {
  const isRoot = route === 'root';

  // After route, we're only allowed links
  if (!href && !isRoot) {
    return null;
  }

  return (
    <li
      className={cx('nav-item', {
        'nav-item--root': isRoot,
        'nav-item--child': !isRoot
      })}>
      {link?.url ? (
        <AbsoluteLinkTag
          title={title}
          href={link.url}
          icon={icon}
          iconColor={iconColor}
          badgeText={badgeText}
        />
      ) : (
        <RelativeLinkTag
          href={href}
          title={title}
          onClick={onClick}
          isInRoute={isInRoute}
          icon={icon}
          iconColor={iconColor}
          badgeText={badgeText}
        />
      )}
      {children}
    </li>
  );
};

NavItem.propTypes = {
  badgeText: PropTypes.string,
  children: PropTypes.node,
  href: PropTypes.string,
  link: PropTypes.object,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  isInRoute: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  route: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export { NavItem };
export default withNavItem(NavItem);
